export default {"src":"/_next/static/media/social.a51b7173.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};